<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">打印评审结果</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
        </div>

        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="80" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="bidSectionCode" label="标段编码" show-overflow-tooltip />
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handlePrint(scope.row)" class="action-btn">
                            打印评委信息
                        </el-button>
                        <el-button type="text" size="small" @click="handleRealTimeReview(scope.row)" class="action-btn">
                            查看实时打分进度
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <!-- 评委信息弹窗 -->
        <el-dialog title="" :visible.sync="expertDialogVisible" width="900px" :close-on-click-modal="false"
            append-to-body>
            <div class="expert-dialog-content">
                <!-- 操作按钮 -->
                <div class="expert-actions">
                    <el-button type="warning" size="small" icon="el-icon-printer"
                        @click="handlePrintExpert">打印</el-button>
                </div>

                <!-- 打印内容区域 -->
                <div id="printContent">
                    <!-- 标题 -->
                    <h3 class="expert-title">评标委员会名单</h3>
                    
                    <!-- 招标信息 -->
                    <div class="expert-info">
                        <p>招标编号：{{ expertInfo.bidSectionCode }}</p>
                        <p class="project-name">项目名称：{{ expertInfo.projectName }}</p>
                        <p class="date-info">{{ formatDate(expertInfo.bidEvaluationStartTime) }}</p>
                    </div>

                    <!-- 评委表格 -->
                    <table class="expert-print-table">
                        <thead>
                            <tr>
                                <th width="80">-</th>
                                <th width="100">姓名</th>
                                <th>单位</th>
                                <th width="120">职务/职称</th>
                                <th width="180">身份证号/证书编号</th>
                                <th width="130">联系电话</th>
                                <th width="100">签名</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(expert, index) in expertInfo.expertList" :key="index">
                                <td style="text-align: center;">{{ getIdentityText(expert.identity) }}</td>
                                <td style="text-align: center;">{{ expert.realName }}</td>
                                <td>{{ expert.company }}</td>
                                <td style="text-align: center;">{{ expert.professionalTitle }}</td>
                                <td style="text-align: center;">{{ expert.idCard }}</td>
                                <td style="text-align: center;">{{ expert.phone }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-dialog>

        <!-- 实时评审进度弹窗 -->
        <el-dialog 
            title="实时查看评审进度" 
            :visible.sync="realTimeReviewDialogVisible" 
            :append-to-body="true" 
            width="70%"
            @close="closeRealTimeReviewDialog"
        >
            <step-real-time-review 
                v-if="realTimeReviewDialogVisible"
                :bid-section-code="currentBidSectionCode"
                ref="realTimeReviewRef"
            />
        </el-dialog>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/projectInfo.js'
import { evaluationResultList, evaluationResultExpertInfo } from '@/api/evaluationReport/api.js'
import StepRealTimeReview from './stepRealTimeReview.vue';

export default {
    name: 'PrintReviewResults',
    components: {
        StepRealTimeReview
    },
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            loading: false,
            currentPage: 1,
            pageSize: 10,
            total: 0,
            tableData: [],
            // 评委信息弹窗
            expertDialogVisible: false,
            realTimeReviewDialogVisible: false,
            currentBidSectionCode: '',
            expertInfo: {
                bidSectionCode: '',
                bidSectionName: '',
                projectCode: '',
                projectName: '',
                bidEvaluationStartTime: '',
                expertList: []
            }
        }
    },
    mounted() {
        this.getProjectInfo()
        this.loadData()
    },
    methods: {

        //  获取标题
        async getProjectInfo() {
            this.projectTitle = await loadProjectDetail(this.projectCode);
        },
        // 加载数据
        loadData() {
            this.loading = true;
            evaluationResultList({
                projectCode: this.projectCode,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                stage: 0
            }).then(res => {
                if (res.code == 200) {
                    // 处理返回数据
                    this.tableData = res.data.records
                    this.total = res.data.total || 0;
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(error => {
                console.error('获取列表失败:', error)
                this.$message.error('获取列表失败')
            }).finally(() => {
                this.loading = false;
            });
        },
        // 查看评委信息
        getExpertInfo(bidSectionCode) {
            evaluationResultExpertInfo({
                bidSectionCode: bidSectionCode,
            }).then(res => {
                if (res.code == 200) {
                    this.expertInfo = res.data || {};
                    this.expertDialogVisible = true;
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(error => {
                this.$message.error('获取评委信息失败')
            });
        },
        // 获取身份文本
        getIdentityText(identity) {
            const identityMap = {
                0: '委员',
                1: '主任',
                2: '副主任'
            };
            return identityMap[identity] || '委员';
        },
        // 格式化日期
        formatDate(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
        },
        // 打印评委信息
        handlePrintExpert() {
            try {
                const printContent = document.getElementById('printContent')
                if (!printContent) {
                    this.$message.error('未找到打印内容')
                    return
                }

                // 创建新窗口进行打印
                const printWindow = window.open('', '_blank')
                
                // 写入HTML内容
                printWindow.document.write(`
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <meta charset="utf-8">
                        <title>评标委员会名单</title>
                        <style>
                            * {
                                margin: 0;
                                padding: 0;
                                box-sizing: border-box;
                            }
                            body {
                                font-family: "Microsoft YaHei", Arial, sans-serif;
                                padding: 20px;
                                font-size: 14px;
                            }
                            .expert-title {
                                font-size: 24px;
                                font-weight: bold;
                                text-align: center;
                                margin-bottom: 30px;
                                color: #333;
                            }
                            .expert-info {
                                margin-bottom: 20px;
                                font-size: 14px;
                                color: #333;
                            }
                            .expert-info p {
                                margin: 8px 0;
                            }
                            .expert-info .project-name {
                                color: #e6a23c;
                                font-weight: 500;
                            }
                            .expert-info .date-info {
                                text-align: right;
                                color: #666;
                            }
                            .expert-print-table {
                                width: 100%;
                                border-collapse: collapse;
                                margin-top: 20px;
                            }
                            .expert-print-table th,
                            .expert-print-table td {
                                border: 1px solid #ddd;
                                padding: 10px 8px;
                                text-align: left;
                            }
                            .expert-print-table th {
                                background: #f5f7fa;
                                font-weight: bold;
                                text-align: center;
                                color: #333;
                            }
                            @media print {
                                @page {
                                    size: A4;
                                    margin: 20mm;
                                }
                                body {
                                    padding: 0;
                                }
                            }
                        </style>
                    </head>
                    <body>
                        ${printContent.innerHTML}
                    </body>
                    </html>
                `)
                
                printWindow.document.close()
                
                // 等待内容加载完成后打印
                printWindow.onload = function() {
                    printWindow.focus()
                    printWindow.print()
                    printWindow.close()
                }
                
                // 兼容性处理：如果 onload 不触发，延迟打印
                setTimeout(() => {
                    if (printWindow.document.readyState === 'complete') {
                        printWindow.focus()
                        printWindow.print()
                        printWindow.close()
                    }
                }, 500)
            } catch (error) {
                console.error('打印失败:', error)
                this.$message.error('打印失败')
            }
        },
        // 导出Excel
        handleExportExcel() {
            this.$message.info('导出Excel功能开发中...');
        },
        // 返回项目流程界面
        handleBack() {
            this.$router.go(-1)
        },
        // 打印评委信息
        handlePrint(row) {
            this.getExpertInfo(row.bidSectionCode)
        },
        handleRealTimeReview(row) {
            this.currentBidSectionCode = row.bidSectionCode
            this.realTimeReviewDialogVisible = true
        },
        closeRealTimeReviewDialog() {
            this.realTimeReviewDialogVisible = false
            //清理子组件状态
            if (this.$refs.realTimeReviewRef) {
                this.$refs.realTimeReviewRef.stopRealTimeRefresh()
            }
        },
        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.loadData();
        },
        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadData();
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

/* 评委信息弹窗样式 */
.expert-dialog-content {
    padding: 0 20px;
}

.expert-actions {
    margin-bottom: 20px;
}

.expert-title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #333;
}

.expert-info {
    margin-bottom: 15px;
    font-size: 14px;
    color: #333;
}

.expert-info p {
    margin: 8px 0;
}

.expert-info .project-name {
    color: #e6a23c;
}

.expert-info .date-info {
    text-align: right;
    color: #666;
}

.expert-table {
    margin-bottom: 20px;
}

::v-deep .expert-table th {
    background-color: #fdf6ec !important;
    color: #333;
}

/* 打印表格样式 */
.expert-print-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.expert-print-table th,
.expert-print-table td {
    border: 1px solid #ddd;
    padding: 10px 8px;
    text-align: left;
}

.expert-print-table th {
    background: #f5f7fa;
    font-weight: bold;
    text-align: center;
    color: #333;
}

.expert-print-table td {
    color: #333;
}

/* 隐藏操作按钮区域，不包含在打印内容中 */
@media print {
    .expert-actions {
        display: none;
    }
}
</style>
